interface VectorListItem {
  number: string;
  icon: string;
  title: string;
  description: string;
}

interface VectorListProps {
  id?: string;
  className: string;
  itemBackground: string;
  vector: string;
  vecLocation: string;
  title: string;
  subTitle: string;
  description: string;
  intro: string;
  content: VectorListItem[];
}

const VectorList: React.FC<VectorListProps> = ({
  id,
  className,
  itemBackground,
  vector,
  vecLocation,
  title,
  subTitle,
  description,
  intro,
  content,
}) => {
  return (
    <div id={id} className={`w-full  cursor-default ${className}`}>
      <div className="mx-auto max-w-7xl px-8 sm:px-10 lg:px-12 py-12">
        <div>
          <div className="flex flex-col md:flex-row items-center gap-8 mb-6">
            {vecLocation === "start" && (
              <img className="w-auto" src={vector} alt="" />
            )}

            <div className="w-full flex flex-col">
              <div className="text-3xl lg:text-4xl font-extrabold uppercase drop-shadow-lightBlue">
                <div className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                  {title}
                </div>
                <div className="text-dark">{subTitle}</div>
              </div>

              <div className="text-justify text-dark/50 text-lg my-4">
                <span className="text-lg font-normal">{description}</span>
                <br />
                <div className="font-bold">{intro}</div>
              </div>
            </div>

            {vecLocation === "end" && (
              <img className="w-auto" src={vector} alt="" />
            )}
          </div>

          <ul className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {content.map((item, index) => (
              <li
                key={index}
                className={`h-auto bg-${itemBackground} p-6 rounded-t-xl rounded-bl-xl drop-shadow-darkBlue transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 ${
                  index === content.length - 1 && index % 2 === 0
                    ? "md:col-span-2"
                    : "col-span-1"
                }`}
              >
                <div className="w-7 -ml-8 -mt-8 bg-primary rounded-t-md rounded-bl-md flex justify-center items-center">
                  <div className="text-lightGray text-lg lg:text-xl font-semibold">
                    {item.number}
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="flex justify-center items-center w-20 h-20 p-4 bg-primary/25 hover:bg-primary/35 rounded-t-xl rounded-bl-xl">
                    <img
                      src={item.icon}
                      alt=""
                      className="w-20 h-20 brightness-100 hover:brightness-125"
                    />
                  </div>
                  <div className="text-dark text-lg lg:text-xl font-bold capitalize leading-relaxed">
                    {item.title}
                  </div>
                </div>

                <div className="text-justify text-dark/50 text-base font-normal mt-4 leading-[21.79px]">
                  {item.description}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default VectorList;
